import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Checkmark from './Checkmark';
const CardContainer = styled.div`
  font-size: 16px;
`;
const CardTitle = styled.div`
font-size: 24px;
font-family: HelveticaNeue-Bold;
font-weight: bold;
letter-spacing: -0.3px;
line-height: 48px;
margin-bottom:5px;
`;


const CardPrice = styled.div`
font-size: 56px;
font-family: HelveticaNeue-Bold;
font-weight: bold;
letter-spacing: -1px;
line-height: 60px;
margin-bottom:5px;
`;


const CardSubtitle = styled.div`
  font-size: 18px;
  font-family: HelveticaNeue-Medium;
  font-weight: 500;
  line-height: 28px;
  margin-bottom:5px;
`;

const CardName = styled(CardSubtitle)`
  font-size: 16px;
  font-weight:bold ;
`


const CardMessage = styled.div`
  margin-bottom: 30px;
  letter-spacing: 0.1px;
  line-height: 24px;
`;

const CardText = styled(CardMessage)`
  margin-bottom:5px;
  padding: 0px 5px;  
  background: ${(props) => props.theme.color.softPurple};
  border-radius:6px;  
  width:fit-content;
  font-size:80%;
`


export default function MembershipComponent({ membership, features, ...rest }) {
  const [arrayFeatures, setArrayFeatures] = useState([])

  useEffect(() => {
    prepareRender(features)

  }, [features])

  function prepareRender(data) {
    let array = data.map((element, index) => {
      return (<CardText key={index}><Checkmark />{element.feature.description}</CardText>)
    });

    setArrayFeatures(array)

  }

  return (<CardContainer style={rest.style}>
    <CardTitle>
      {membership.name} access
    </CardTitle>
    <CardPrice>
      {Boolean(membership.payment_interval) ?
        (
          <div>
            {membership.price / membership.payment_interval} <CardSubtitle as="label"> month *</CardSubtitle>
          </div>
        ):
        (<div>{membership.price} <CardSubtitle as="label"> once *</CardSubtitle></div>)}
    </CardPrice>
    <CardMessage>
      {Boolean(membership.payment_interval) ? `* Billed Annually at $${membership.price} / year`
        : '* Billed once in a life time'}
    </CardMessage>
    <CardName>{membership.name} Membership</CardName>
    {arrayFeatures}
  </CardContainer>)
}